module.exports = __webpack_public_path__ + "media/images/savaan-icon-0da7d3da01d897809b77cdfefeb36dd8.svg";